module.exports = __webpack_public_path__ + "static/band3.ff5b6ede.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/band3.jpg
// module id = 390
// module chunks = 35783957827783 195814232070997